import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ImpressionTypeFilter } from '../../../../AITemplates/ImpressionTypeFilter';
import { ImpressionType } from './GenerateMenuModal';

const messages = defineMessages({
  impressionTypeCaption: {
    id: 'phc-web-toolkit.aiTemplates.impressionTypeSelect.impressionTypeCaption',
    defaultMessage:
      'Select a section to regenerate. Selecting "All" will regenerate all non-edited sections by default.',
  },
});

type ImpressionTypeSelectProps = {
  impressionType: ImpressionType;
  availableImpressionTypes: ImpressionType[];
  setImpressionType: (impressionType: ImpressionType) => void;
};

export const ImpressionTypeSelect = ({
  impressionType,
  availableImpressionTypes,
  setImpressionType,
}: ImpressionTypeSelectProps) => {
  const { formatMessage } = useIntl();
  // watch for changes in available impression types
  // if the impression type is not in the available impression types, set it to all
  useEffect(() => {
    if (!availableImpressionTypes.includes(impressionType)) {
      setImpressionType('all');
    }
  }, [availableImpressionTypes, impressionType, setImpressionType]);

  return (
    <ImpressionTypeFilter
      value={impressionType}
      impressionTypes={availableImpressionTypes.filter(i => i !== 'all')}
      onChange={impressionType =>
        setImpressionType(impressionType as ImpressionType)
      }
      extraSections={['all']}
      variant="form-field"
      disabled={false}
      impressionTypeCaption={formatMessage(messages.impressionTypeCaption)}
    />
  );
};
